import { useEffect } from "react";
import ReactMarkdown from "react-markdown";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { Container, Row, Col } from "react-bootstrap";
import InnerPageLayout from "../../Components/Layout/InnerPageLayout";
import { getOneNewsItem } from "../../api/api";
import { ImageData } from "../../types/news"; // Assuming you have these types defined

const NewsPage = () => {
  let { id } = useParams();

  const { i18n } = useTranslation();

  const { isLoading, error, data, refetch }: any = useQuery(
    "newsData",
    () => getOneNewsItem({ id: id || "1", language: i18n.language })
  );

  useEffect(() => {
    refetch();
  }, [i18n.language, refetch]);

  if (isLoading || !data) return <div>Loading...</div>;
  if (error) return <div>Error loading news item.</div>;

  const newsItem = data.data;

  console.log(newsItem);


  return (
    <InnerPageLayout>
      <>
      <Helmet>
        <title>{newsItem.Title}</title>
        <meta name="description" content={newsItem.SubTitle} />
      </Helmet>
      <Container>
        <Row>
          <Col md={12}>
            <div>
              <h1>{newsItem.attributes.Title}</h1>
              <h4>{newsItem.attributes.SubTitle}</h4>
              <ReactMarkdown>{newsItem.attributes.Content}</ReactMarkdown>
              <div style={{ height: '30px', width: '100%' }}></div>
            </div>
            {newsItem.attributes.Images.data.map((image: ImageData, index: number) => (
              <img
                key={index}
                src={`${process.env.REACT_APP_CMS}${image.attributes.url}`}
                style={{ width: '100%', marginBottom: '50px' }}
                alt={newsItem.attributes.Title}
              />
            ))}
          </Col>
         
        </Row>
      </Container>
      </>
    </InnerPageLayout>
  );
};

export default NewsPage;
